import {
  CREATE_CUSTOMER,
  UPDATE_CUSTOMER,
  LOAD_CUSTOMER,
  REMOVE_LISTS,
  LOAD_CUSTOMER_DETAIL
} from "./actions";

const initialState = {
  lists: [],
  total: 1,
  loading: false,
  detailLoading: false,
  draw: -1,
  selectedCustomer: {
    customer_id: null,
    title: "-",
    firstname: "",
    lastname: "",
    phone_number: "",
    phone_number_2: "",
    nationality: "-",
    customer_type: "Personal"
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;
    case LOAD_CUSTOMER.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading
      };
    case LOAD_CUSTOMER.SUCCESS:
      const { page } = action.payload;
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1;
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10;
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    case LOAD_CUSTOMER_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case LOAD_CUSTOMER_DETAIL.SUCCESS:
      return {
        ...state,
        selectedCustomer: action.payload.customer.data,
        detailLoading: false
      };
    case CREATE_CUSTOMER.SUCCESS:
      const { res } = action.payload;
      return {
        ...state,
        selectedCustomer: { ...state.booking, customer_id: res.customer_id },
        customer_id: res.customer_id,
        detailLoading: false
      };
    case UPDATE_CUSTOMER.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case UPDATE_CUSTOMER.SUCCESS:
      return {
        ...state,
        detailLoading: false,
        selectedCustomer: initialState.selectedCustomer
      };
    default:
      return state;
  }
};
